import httpClient from './http-client';

// except challenge
const endpoint = 'api/security/2fa';

const twoFactorService = {
  // LOGIN 2FA - without auth header (token not yet available)
  // Login confirmation after "2fa_required"
  // otp_code or recovery_code must be provided
  challenge: (payload) =>
    // No Authorization is needed for this endpoint – httpClient should not add Bearer
    httpClient.post(
      'api/auth/2fa/challenge',
      payload,
      { __noAuth: true }
    ),

  // SETUP 2FA - requires authentication (auth:api)
  // QR code or otpauth URL (requires authentication)
  setup() {
    return httpClient.get(`${endpoint}/setup`);
  },

  // Enabling - user provides 6 digits (must be logged in)
  enable(otp_code) {
    return httpClient.post(`${endpoint}/enable`, { otp_code });
  },

  // Disabling - user provides OTP (must be logged in)
  // otp_code or recovery_code must be provided
  disable(payload) {
    return httpClient.post(`${endpoint}/disable`, payload );
  },

  // Recovery codes list (masked)
  listRecovery() {
    return httpClient.get(`${endpoint}/recovery`);
  },

  // Regeneration – ask for OTP (safer)
  regenerateRecovery(otp_code) {
    return httpClient.post(`${endpoint}/recovery/regenerate`, { otp_code });
  },
};

export default twoFactorService;